import { badgePaymentVariants } from '@/components/ui/StatusBadge/StatusBadgeBills';
import { StateBill } from '@/interfaces';
import { VariantProps } from 'class-variance-authority';

// Mapea cada estado interno al nombre de variante en español
export const stateToVariantBill: Record<
	StateBill,
	VariantProps<typeof badgePaymentVariants>['variant']
> = {
	[StateBill.PENDIENTE]: 'Pendiente',
	[StateBill.PAGADO]: 'Pagada',
	[StateBill.CANCELADA]: 'Cancelada',
};
